<template>
  <div class="radio-button-main" :style="{ display: isHorizontal ? 'flex' : '', border: showBox ? '1px solid rgba(128,128,128,0.5)' : 'none',
    marginTop: title ? '5px' : '', paddingTop: title ? '12px' : '' }">
    <div class="title" v-if="title" :style="{ left: showBox ? '5px' : '0px' }">
      <div v-if="isRequired" style="color: red; padding-right: 5px">**</div>
      <div>{{ title }} {{ maxSelect > 1 ? `(Max: ${maxSelect})` : '' }}</div>
      <div v-if="errorMessage" class="error-message" @mouseenter="errorHover('in', $event)" @mouseleave="errorHover('out', $event)">{{ errorMessage }}</div>
    </div>
    <CheckBox class="check-box" v-for="(c, ind) in buttons" :key="ind" :title="c[itemKey]" :isChecked.sync="c['checked']"
      @checkBoxClicked="checkBoxClicked(ind)" :isDisabled="isDisabled" />
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {},
  data: function() {
    return {
      checkedDetails: [],
    }
  },
  props: {
    // Public Properties
    maxSelect: { type: Number, default: 1 }, // You can set the number of maximum items that can be selected
    title: { type: String, default: 'Radio Button Title' }, // The title of the radio button section

    buttons: { type: Array, default: function() { return [] } }, // The array of objects that will be shown at the check boxes
    // format: [
    //   {
    //     title: "Button 1", // the key to be displayed as the button text should be passed to the itemKey prop
    //     checked: false, // to keep track of which button is checked
    //   },
    //   {
    //     title: "Button 2",
    //     checked: true,
    //   },
    // ]

    itemKey: { type: String, default: '' }, // The key of the object to show as the Checkbox title
    isHorizontal: { type: Boolean, default: false }, // If true, the radio buttons will appear in a row
    showBox: { type: Boolean, default: true }, // If false, the box around the radiobuttons will be removed
    isRequired: { type: Boolean, default: false }, // If true, user needs to select at least one
    errorMessage: { type: String, default: '' }, // If true, user needs to select at least one
    isDisabled: { type: Boolean, default: false }, // To set the checkbox not clickable

    // rollingSelection: { type: Boolean, default: true }, // If true, the first item will be deselected automatically once you selected the next item, if false, an error will appear saying that you can only selected (max value) only
  },
  methods: {
    checkBoxClicked: function(index) {
      this.$emit('update:errorMessage', '');
      let isChecked = this.buttons[index]['checked'];

      if (isChecked) {
        this.checkedDetails.push({ index: index, time: new Date().getTime() });
        let sorted = this.checkedDetails.sort((a, b) => { return a['time'] - b['time'] });

        if (this.checkedDetails.length > this.maxSelect) {
          this.buttons[sorted[0]['index']]['checked'] = false;
          let deleteIndex = this.checkedDetails.indexOf(sorted[0]);
          this.checkedDetails.splice(deleteIndex, 1);  
        }
      } else {
        let deleteIndex = this.checkedDetails.indexOf(this.checkedDetails.find(c => c['index'] == index));
        this.checkedDetails.splice(deleteIndex, 1);
      }
    },
    errorHover: function(state, e) {
      let error = e.target;
      let parent = error.parentNode;
      
      if (state == 'in') {
        error.classList.add('error-message-hover');
        parent.classList.add('title-hover');
      } else {
        error.classList.remove('error-message-hover');
        parent.classList.remove('title-hover');
      }
    }
  },
  mounted() {
    this.buttons.forEach((b, i) => {
      if (b['checked']) {
        this.checkedDetails.push({ index: i, time: new Date().getTime() });
      }
    });
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.radio-button-main {
  position: relative;
  padding: 5px 10px 5px 5px;
  height: fit-content;
  // width: 250px;
  width: 100%;
  border-radius: 3px;
  // margin-top: 5px;
  flex-wrap: wrap;

  > .check-box {
    flex-grow: 1; 
  }

  > .title {
    position: absolute;
    top: -12px;
    background-color: white;
    width: fit-content;
    padding: 3px 7px;
    display: flex;
    max-width: 75%;
    overflow: hidden;

    > .error-message {
      background-color: red;
      color: white;
      padding: 0 5px;
      margin-left: 5px;
      border-radius: 5px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    > .error-message-hover {
      overflow: visible;
      border: 1px solid black;
    }
  }

  > .title-hover {
    overflow: visible;
  }
}
</style>